import { useEffect } from 'react';
import { usePermissions } from '@/context/PermissionsContext';
import { chatActions } from './chatStore';
import { chatNotify } from './chatNotify';

// Mantiene el Chat conectado en todo el ERP (para avisar de mensajes nuevos desde cualquier sección)
export const ChatRealtimeHost = ({ pathname }) => {
  const { can } = usePermissions();
  const enabled = can('chat', 'ver');
  useEffect(() => (enabled ? chatActions.connectRealtime() : undefined), [enabled]);
  useEffect(() => { chatNotify.setOnChat(pathname.startsWith('/app/chat')); return () => chatNotify.setOnChat(false); }, [pathname]);
  return null;
};
